import React, { useCallback, useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";
import { upscaleSingle } from "../../../../../services/api/tools/upscale";
import { upscaleCreditCost } from "../../../../../data/aiOperationCredits";

const PRESETS = [
  {
    id: "fast",
    label: "Fast",
    sub: "Quick",
    tip: presetTip('Fast — "Quick"', [
      "Fastest upscale",
      "Good for drafts and previews",
      "Lowest processing time",
    ]),
  },
  {
    id: "balanced",
    label: "Balanced",
    sub: "Recommended",
    tip: presetTip('Balanced — "Recommended"', [
      "Good detail recovery for most images",
      "Default choice for product and portrait shots",
    ]),
  },
  {
    id: "best",
    label: "Best",
    sub: "Max detail",
    tip: presetTip('Best — "Max detail"', [
      "Strongest detail reconstruction",
      "Best for soft or low-res sources",
      "May invent fine textures",
    ]),
  },
];

const SCALES = [
  {
    id: "2x",
    label: "2×",
    sub: "Double",
    tip: presetTip('2× — "Double"', [
      "Doubles width and height",
      "Good everyday upscale",
    ]),
  },
  {
    id: "4x",
    label: "4×",
    sub: "Quad",
    tip: presetTip('4× — "Quad"', [
      "Quadruples resolution",
      "Use for large prints or heavy crops",
    ]),
  },
];

/**
 * AI Tools → AI Upscale prep.
 */
const UpscaleToolPrep = (props) => {
  const [presetId, setPresetId] = useState("balanced");
  const [scaleId, setScaleId] = useState("2x");

  const handleGenerate = useCallback(
    async ({ token, file, image_url }) =>
      upscaleSingle(token, file, {
        quality: presetId,
        scale: scaleId,
        output_format: "png",
        ...(presetId === "best" ? { polish: true } : {}),
        ...(image_url ? { image_url } : {}),
      }),
    [presetId, scaleId]
  );

  return (
    <AiFeatureToolPrep
      {...props}
      onGenerate={handleGenerate}
      generateFileName="upscale-input.png"
      toolKey="ai_upscale"
      creditCost={upscaleCreditCost(scaleId, presetId)}
      title="AI Upscale"
      aka="Image Upscaler"
      bio="Increase resolution and recover detail for sharper large images."
      emptyPreviewLabel="Upload an image to preview upscale"
      loadingLabel="Upscaling…"
      emptyFooterHint="Upload an image, pick scale and preset, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Preset</p>
            <AiPresetCards
              presets={PRESETS}
              selectedId={presetId}
              ariaLabel="Upscale preset"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setPresetId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <p className="aftp-label">Scale</p>
            <AiPresetCards
              presets={SCALES}
              selectedId={scaleId}
              columns={2}
              ariaLabel="Upscale scale"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setScaleId(id);
              }}
            />
          </div>
        </>
      )}
    />
  );
};

export default UpscaleToolPrep;
